import Banner from "../components/Banner/Banner";
import Footer from "../components/Footer/Footer";
import Navigation from "../components/Navigation/Navigation";
import Spinner from "../components/Spinner/Spinner";

function AboutUs() {
  return (
    <div className="container-xxl bg-white p-0">
      <Spinner />
      <Navigation />
      <Banner pageName="About Us" />
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
              <div className="row g-0 about-bg rounded overflow-hidden">
                <div className="col-6 text-start">
                  <img
                    className="img-fluid w-100"
                    src={`https://picsum.photos/seed/${Math.random()}/306`}
                    alt=""
                  />
                </div>
                <div className="col-6 text-start">
                  <img
                    className="img-fluid"
                    src={`https://picsum.photos/seed/${Math.random()}/260`}
                    alt=""
                    style={style.image1}
                  />
                </div>
                <div className="col-6 text-end">
                  <img
                    className="img-fluid"
                    src={`https://picsum.photos/seed/${Math.random()}/260`}
                    alt=""
                    style={style.image2}
                  />
                </div>
                <div className="col-6 text-end">
                  <img
                    className="img-fluid w-100"
                    src={`https://picsum.photos/seed/${Math.random()}/306`}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
              <h1 className="mb-4">
                We Help To Get The Best Job And Find A Talent
              </h1>
              <p className="mb-4">
                Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit.
                Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit,
                sed stet lorem sit clita duo justo magna dolore erat amet
              </p>
              <p>
                <i className="fa fa-check text-primary me-3"></i>Tempor erat
                elitr rebum at clita
              </p>
              <p>
                <i className="fa fa-check text-primary me-3"></i>Aliqu diam amet
                diam et eos
              </p>
              <p>
                <i className="fa fa-check text-primary me-3"></i>Clita duo justo
                magna dolore erat amet
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

const style = {
  image1: { width: "85%", marginTop: "15%" },
  image2: { width: "85%" },
};

export default AboutUs;
